import {
  DataObjectInfiniteSearchOptions,
  DataObjectOption,
  useInfiniteSearchDataObjectsQuery,
} from '../../dataobject/query/useInfiniteSearchDataObjectsQuery';
import { useSelectedDataObjectsQuery } from '../../dataobject/query/useSelectedDataObjectsQuery';
import { DataObjectOutputType, DataObjectType } from '../../dataobject/types';

import { useMemo } from 'react';
import { formatCodeName } from '../utils';
import {
  InfiniteSearchSelect,
  InfiniteSearchSelectProps,
} from './InfiniteSearchSelect';

export interface DataObjectDescriptionAutoCompleteProps
  extends Omit<
    InfiniteSearchSelectProps<
      number[],
      DataObjectOption,
      DataObjectInfiniteSearchOptions
    >,
    'defaultOption' | 'defaultOptions' | 'searchOptions' | 'useSearchHook'
  > {
  defaultOption?: number[];
  dataObjectType?: DataObjectType;
  outputTypeCodes?: DataObjectOutputType[];
  excludedOutputTypeCodes?: DataObjectOutputType[];
}

export function DataObjectDescriptionAutoComplete(
  props: DataObjectDescriptionAutoCompleteProps,
) {
  const {
    defaultOption,
    dataObjectType,
    outputTypeCodes,
    excludedOutputTypeCodes,
    ...rest
  } = props;

  const { data: preSelected, isFetching: isFetchingSelected } =
    useSelectedDataObjectsQuery(defaultOption);

  const searchOptions = useMemo(
    () => ({
      dataObjectType,
      outputTypeCodes,
      excludedOutputTypeCodes,
    }),
    [dataObjectType, excludedOutputTypeCodes, outputTypeCodes],
  );
  const defaultOptions = useMemo(
    () =>
      preSelected?.map((item) => ({
        value: item.id,
        label: formatCodeName(item),
        item,
      })),
    [preSelected],
  );

  return (
    <InfiniteSearchSelect
      {...rest}
      mode="multiple"
      defaultOptions={defaultOptions}
      loading={isFetchingSelected}
      searchOptions={searchOptions}
      useSearchHook={useInfiniteSearchDataObjectsQuery}
    />
  );
}
